import { getNativePath } from './deeplink';
import { isApp } from './env';

export const APPS_FLYERS = 'byAppsFlyers';
const CDN_URL =
  '/common-static/cht-static/user-svc/js/by_appsflyer_c67e7b7d.js';

let loadByAppsFlyerPromise = null;

/**
 * @description
 *  smart banner 中需要挑转的 url，该 url 为 app 中的 deep link url
 *
 *  step1: 优先从 getNativePath 中获取 deep link url；
 *  step2: 如果获取不到，则默认跳转到 app 内部的 webview 页
 *
 * @docs
 *  Appsflyer 二期文档：https://uponly.larksuite.com/wiki/DJKkwTVGhilhMykAhsZuSxecsQe
 *  Appsflyer 一期文档：https://uponly.larksuite.com/wiki/ADePwgujrie8JHkYt2tuUpvOsBb
 *  deep link 列表：https://uponly.larksuite.com/wiki/wikusD9jgDR1NDnLhWwhn6IeJ7f
 *
 * @param href 默认值为 window.location.href
 * @returns deep link url
 */
export const getDeepLinkUrl = (href: string = window.location.href): string => {
  const nativePath = getNativePath(href);

  const deepLink = nativePath
    ? nativePath.path
    : `bybitapp://open/web?url=${encodeURIComponent(href)}`;

  return deepLink;
};

export const loadByAppsFlyerScript = (notDelayLoad = false) => {
  if (loadByAppsFlyerPromise) {
    return loadByAppsFlyerPromise;
  }
  loadByAppsFlyerPromise = new Promise((resolve, reject) => {
    if (window[APPS_FLYERS] || isApp()) {
      resolve(true);
      return;
    }
    const script = document.createElement('script');
    script.id = 'ByAppsFlyers';
    script.src = CDN_URL;
    script.defer = true;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      loadByAppsFlyerPromise = null;
      reject();
    };
    // Delay to append script avoiding lighthouse performance
    if (notDelayLoad) {
      document.body.appendChild(script);
    } else {
      if (document.readyState === 'complete') {
        document.body.appendChild(script);
      } else {
        window.addEventListener('load', () => {
          document.body.appendChild(script);
        });
      }
    }
  });

  return loadByAppsFlyerPromise;
};

export const triggerOneLink = async (href: string, channelParams = true) => {
  try {
    await loadByAppsFlyerScript();

    let nativePath;

    if (href.startsWith('bybitapp://')) {
      nativePath = { path: href };
    } else if (href.startsWith('by-mini://')) {
      nativePath = {
        path: `bybitapp://open/route?targetUrl=${encodeURIComponent(href)}`,
      };
    } else {
      nativePath = getNativePath(href);
    }

    const handledOneLink = await window[APPS_FLYERS]?.triggerOneLink?.(
      nativePath ? nativePath.path : '',
      channelParams
    );

    return handledOneLink;
  } catch (e) {
    console.warn('triggerOneLink fail, cause:', e);
  }
};
